import React from 'react'


import Breadcrumb from './Breadcrumb';

import PowerplantListing from './Powerplantlisting';



function PowerplantPage() {
    return ( 
        <>
        
        <Breadcrumb />
     
        <PowerplantListing />

        {/* <Herobottom /> */}
        

        </>
     );
}

export default PowerplantPage;